export default __webpack_public_path__ + "static/rickshaw-6cfa8addfa971ec97bb740094fe5b7d2.svg";